import { render, staticRenderFns } from "./FiltersInvitesUBA.vue?vue&type=template&id=17cbb021&scoped=true&"
import script from "./FiltersInvitesUBA.vue?vue&type=script&lang=js&"
export * from "./FiltersInvitesUBA.vue?vue&type=script&lang=js&"
import style0 from "./FiltersInvitesUBA.vue?vue&type=style&index=0&id=17cbb021&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cbb021",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCol,VRow,VSelect,VTextField})
